import { createReducer, isAnyOf } from "@reduxjs/toolkit";
import { omit } from "lodash";
import { GlobalEntityType } from "shared/types";
import initialState from "./cell-model-list.store";
import { cellModelClearParsedData, cellModelImportFromFileId, cellModelImportFromFileIdFailure, cellModelImportFromFileIdSuccessful, loadCellModelList, loadCellModelListFailure, loadCellModelListSuccessful, parseCellModelFileId, parseCellModelFileIdFailure, parseCellModelFileIdSuccessful, uploadCellModel, uploadCellModelFailure, uploadCellModelSuccessful, } from "./cell-model-list.actions";
import { setKnowledgeBaseItemsFilterExcludedTags, setKnowledgeBaseItemsFilterIncludedTags, setKnowledgeBaseItemsLastUsedSortingDirection, setKnowledgeBaseItemsNameSortingDirection, setKnowledgeBaseItemsOwnershipFilter, setKnowledgeBaseItemsSearchQuery, } from "store/knowledge-base-items-list/knowledge-base-items-list.actions";
import { revokeOwnershipSuccessful, shareOwnershipSuccessful, } from "store/knowledge-base-item/knowledge-base-item.actions";
export default createReducer(initialState, (builder) => {
    builder
        .addCase(loadCellModelListSuccessful, (state, { payload }) => {
        state.items = payload;
    })
        .addCase(setKnowledgeBaseItemsSearchQuery, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.CellModel) {
            state.searchQuery = payload.query;
        }
    })
        .addCase(setKnowledgeBaseItemsOwnershipFilter, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.CellModel) {
            state.ownershipFilter = payload.ownershipFilter;
        }
    })
        .addCase(setKnowledgeBaseItemsNameSortingDirection, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.CellModel) {
            state.sortingDirections.name = payload.direction;
        }
    })
        .addCase(setKnowledgeBaseItemsLastUsedSortingDirection, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.CellModel) {
            state.sortingDirections.lastUsed = payload.direction;
        }
    })
        .addCase(setKnowledgeBaseItemsFilterIncludedTags, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.CellModel) {
            state.tagsFilters.included = payload.tags;
        }
    })
        .addCase(setKnowledgeBaseItemsFilterExcludedTags, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.CellModel) {
            state.tagsFilters.excluded = payload.tags;
        }
    })
        .addCase(parseCellModelFileIdSuccessful, (state, { payload }) => {
        state.parsedData = payload;
    })
        .addCase(uploadCellModelSuccessful, (state, { payload }) => {
        state.importFileId = payload;
    })
        .addMatcher(isAnyOf(uploadCellModel, cellModelImportFromFileIdSuccessful, cellModelClearParsedData), (state) => {
        state.parsedData = null;
        state.importFileId = null;
    })
        .addMatcher(isAnyOf(uploadCellModel, parseCellModelFileId, cellModelImportFromFileId, loadCellModelList), (state) => {
        state.loading = true;
    })
        .addMatcher(isAnyOf(shareOwnershipSuccessful, revokeOwnershipSuccessful), (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.CellModel) {
            const existingItem = state.items.find(({ id }) => id === payload.knowledgeBaseItem.id);
            state.items = [
                ...state.items?.filter(({ id }) => id !== payload.knowledgeBaseItem.id),
                { ...existingItem, ...omit(payload.knowledgeBaseItem, "state") },
            ];
        }
    })
        .addMatcher(isAnyOf(loadCellModelListSuccessful, loadCellModelListFailure, uploadCellModelFailure, parseCellModelFileIdFailure, parseCellModelFileIdSuccessful, cellModelImportFromFileIdSuccessful, cellModelImportFromFileIdFailure), (state) => {
        state.loading = false;
    });
});
